import React from "react";
// Removed useState, useNavigate, and specific Firebase imports as they are handled by MultiStepRegister
// Removed specific Material-UI component imports like TextField, Button, Select, etc.
// Kept Typography for the page title, assuming it's not part of MultiStepRegister's main container.
// If MultiStepRegister includes its own title like "Register", Typography can also be removed.
import Typography from '@mui/material/Typography'; 
import MultiStepRegister from "./registration/MultiStepRegister.js"; // Import the new component

function Register() {
  // All state variables (email, password, etc.) and event handlers (handleSubmit, handleFileChange)
  // related to the old form have been removed.

  return (
    // The main div wrapper can be kept for consistent page styling if needed,
    // or MultiStepRegister can handle its own top-level container.
    // For now, keeping the div to maintain similar structure to other pages.
    // The "Register" title is kept here, but could also be moved into MultiStepRegister.
    // If MultiStepRegister handles its own max-width and padding, this div might become redundant.
    <div style={{ maxWidth: "600px", margin: "auto", padding: "20px" }}> 
      {/* The Typography for title is kept. MultiStepRegister already has its own title.
          This might result in two titles. The one inside MultiStepRegister is more integrated.
          Decided to remove this external Typography as MultiStepRegister has its own centered title.
      */}
      {/* 
      <Typography variant="h6" gutterBottom align="center"> 
        Register
      </Typography>
      */}
      <MultiStepRegister />
    </div>
  );
}

export default Register;
